// Real customer reviews collected from Silver Jarz's Google Business
// profile, translated to English. Source language was Arabic (auto-
// translated by Google on the original listing).
//
// avatar: generated via ui-avatars.com from the reviewer's initials —
// Google doesn't expose reusable profile photos through its public
// review surfaces, so this keeps a consistent, on-brand look instead
// of leaving broken image paths.

export const testimonial1 = [
  {
    id: 1,
    avatar: "https://ui-avatars.com/api/?name=Amjad+Salah&background=294b5a&color=d3be76&bold=true",
    name: "Amjad Salah",
    designation: "2 reviews on Google",
    rating: 5,
    text: `I'm very grateful to the agency, and this isn't the first time
        I've worked with them. Honestly, they are trustworthy and
        transparent. I never asked them for anything they couldn't deliver,
        and they were always a great help. Very cooperative and patient —
        we've had many interactions regarding the Dibba Sea View Hotel.
        I'm truly grateful to them.`,
    dealyAnimation: "100",
  },
  {
    id: 2,
    avatar: "https://ui-avatars.com/api/?name=Salsabeel+Ahmed&background=294b5a&color=d3be76&bold=true",
    name: "Salsabeel Ahmed",
    designation: "2 reviews on Google",
    rating: 5,
    text: `The best in terms of service and the fastest in terms of
        responsiveness. Thank you for your excellent service.`,
    dealyAnimation: "200",
  },
  {
    id: 3,
    avatar: "https://ui-avatars.com/api/?name=Iresh+Chamara&background=294b5a&color=d3be76&bold=true",
    name: "Iresh Chamara",
    designation: "3 reviews on Google",
    rating: 5,
    text: `I'm Sri Lankan and live in Khasab, Oman. Before contacting Silver
        Jarz, I had already applied for a UAE visa four times through
        another agency, and all four were refused — with no proper support
        or customer service along the way.

        Then I found Silver Jarz. I explained why my previous applications
        had failed, and they were professional and confident they could
        help. They kept their word: I got my 5-year UAE visa in just three
        days.

        I'm extremely grateful for their excellent service, professionalism
        and reliability. I highly recommend Silver Jarz to anyone looking
        for a trustworthy visa agency that actually delivers on its
        promises.`,
    dealyAnimation: "300",
  },
  {
    id: 4,
    avatar: "https://ui-avatars.com/api/?name=Hamad+Jarah&background=294b5a&color=d3be76&bold=true",
    name: "Hamad Jarah",
    designation: "Local Guide · 10 reviews on Google",
    rating: 5,
    text: `The service was excellent, and Mr. Abdullah Zayed was very
        respectful and kind. He processed my visa in a single day.`,
    dealyAnimation: "400",
  },
];
export const testimonial2 = [
  {
    id: 1,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/1.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "100",
  },
  {
    id: 2,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/2.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "200",
  },
  {
    id: 3,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/3.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "300",
  },
  {
    id: 4,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/4.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "400",
  },
  {
    id: 5,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/avatars/testimonials/5.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
    dealyAnimation: "500",
  },
];

export const testimonial3 = [
  {
    id: 1,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/1.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 2,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/2.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 3,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/3.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 4,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/4.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
  {
    id: 5,
    meta: "Hotel Equatorial Melaka",
    avatar: "/img/testimonials/2/5.png",
    name: "Annette Black",
    designation: "UX / UI Designer",
    text: `"Our family was traveling via bullet train between cities in
    Japan with our luggage - the location for this hotel made that so
    easy. Agoda price was fantastic."`,
  },
];
